module.exports = __webpack_public_path__ + "img/user2-img3.6e339949.jpg";